import { useEffect, useState } from 'react';
import {
    CampusApplicationItemAdded,
    CampusApplicationItemRemoved,
} from '~/Features/CampusApplication/Events/CampusApplicationEvents';
import { useMessageHandler } from '~/Features/Messaging/useMessageHandler';
import {
    OnlineApplicationItemAdded,
    OnlineApplicationItemRemoved,
} from '~/Features/OnlineApplication/Events/OnlineApplicationEvents';
import { ApplicationProgressState, getApplicationProgressState } from '~/Partials/Nav/ApplicationProgressState';

export interface BasketButtonModelProps {
    studySearchPageUrl: string;
    campusApplicationUrl: string;
    onlineApplicationUrl: string;
}

export const useBasketButtonModel = ({
    studySearchPageUrl,
    campusApplicationUrl,
    onlineApplicationUrl,
}: BasketButtonModelProps) => {
    const [state, setState] = useState(ApplicationProgressState.NoApplicationInProgress);

    const updateState = () => setState(getApplicationProgressState());

    useEffect(() => {
        updateState();
    }, []);

    useMessageHandler(CampusApplicationItemAdded.id, updateState);
    useMessageHandler(CampusApplicationItemRemoved.id, updateState);
    useMessageHandler(OnlineApplicationItemAdded.id, updateState);
    useMessageHandler(OnlineApplicationItemRemoved.id, updateState);

    const getBasketLinkUrl: () => string = () => {
        switch (state) {
            case ApplicationProgressState.NoApplicationInProgress:
                return studySearchPageUrl;
            case ApplicationProgressState.CampusApplicationInProgress:
                return campusApplicationUrl;
            case ApplicationProgressState.OnlineApplicationInProgress:
                return onlineApplicationUrl;
            default:
                throw new Error(`Unrecognized ApplicationProgressState  value: ${state}.`);
        }
    };

    const isApplicationInProgress = state !== ApplicationProgressState.NoApplicationInProgress;
    const basketLinkUrl = getBasketLinkUrl();

    return {
        isApplicationInProgress,
        basketLinkUrl,
    };
};
